// @flow
import React from 'react';
import { withRouter } from 'react-router';
import { actions } from 'react-redux-form';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';

import { createTargetModal } from '../../modals/CreateTargetFormModal';
import ControlWrapper from '../controls/ControlWrapper';

const TargetsSelector = ({ params, baseModel }) => {
  const dispatch = useDispatch();
  const project = useSelector(state => state.projects[params.projectKey]);
  const targets = project.targets;

  const handleTargetChange = (model, value) => {
    if (!value) return;

    const conditionModel = model.substr(0, model.lastIndexOf('.'));
    dispatch(actions.change(conditionModel, {
      operator: '',
      values: [],
      target: value.key
    }));
  };

  const handleNewOption = (formProps) => (option) => {
    createTargetModal(option.key, project)
      .then(value => {
        if (value) {
          const conditionModel = formProps.model.substr(0, formProps.model.lastIndexOf('.'));
          dispatch(actions.change(conditionModel, {
            operator: '',
            values: [],
            target: value.key
          }));
        }
      });
  };

  return (
    <ControlWrapper
      model=".target"
      placeholder="Target"
      component={Select.Creatable}
      validateOn={['blur', 'change']}
      ignore={['blur']}
      errorMessages={{ isRequired: 'Required' }}
      clearable={false}
      changeAction={handleTargetChange}
      options={targets}
      valueKey="key"
      labelKey="name"
      mapProps={{
        onNewOptionClick: handleNewOption
      }}
    />
  );
};

export default withRouter(TargetsSelector);